import { useMemo } from "react";
import { getItemSize } from "../menu/Menu.style";
import { useCalculateVisibleItems } from "../menu/useCalculateVisibleItems";
export const useCalcDropdownItems = ({ autoCompleteVisibleItems, visible, autoCompleteItems, size = "small", }) => {
    const menuItemSize = useMemo(() => getItemSize({ size, multiSelect: false }), [size]);
    const { visibleItems } = useCalculateVisibleItems({
        dropdownVisibleItems: autoCompleteVisibleItems,
        visible,
        dropdownItemsLength: autoCompleteItems.length,
        extraHeight: 0,
        menuItemSize,
    });
    return { visibleItems };
};
//# sourceMappingURL=useCalcDropdownItems.js.map